import React, { useEffect, useContext } from 'react';
import {
  doc,
  getDoc
} from 'firebase/firestore';

import {
  db
} from "../utils/firebase";

import { TokenContext } from "./tokenContext"; // import TokenContext
import { logout } from "../utils/firebase";
import { createPortal } from "react-dom";
import GlobalNavDrawer from "./GlobalNavDrawer";
import { useAuth } from './AuthContext';
import "./JobBankAbout.css";

export default function JobBankAbout() {
  const { balance, setBalance } = useContext(TokenContext);
  const { currentUser } = useAuth();

  useEffect(() => {
      let isMounted = true;
  
      const fetchTokens = async () => {
        if (!currentUser?.uid) return;
  
        const userRef = doc(db, "users", currentUser.uid);
  
        try {
          const userDoc = await getDoc(userRef);
  
          if (userDoc.exists() && isMounted) {
            setBalance(userDoc.data().tokens ?? 0);
          }
        } catch (error) {
          console.error("Error fetching token count:", error);
        }
      };
  
      fetchTokens();
  
      return () => {
        isMounted = false;
      };
    }, [currentUser, setBalance]);

  return (
    <div className="jba-container">

      <div className="jba-hero">

        <h1>Community Job Bank</h1>

        <p>
          Building stronger communities by connecting
          local talent with local opportunity.
        </p>

      </div>

      <div className="jba-section">

        <h2>Our Mission</h2>

        <p>
          The Community Job Bank exists to
            strengthen local labour markets by
            bringing employers, job seekers,
            career coaches, and community partners
            together in one connected platform.

            We believe employment is more than
            a transaction. It is a relationship.

            By combining job postings, career
            coaching, hiring events, messaging,
            and employer engagement tools, we help
            create meaningful employment outcomes
            that benefit individuals, businesses,
            and communities alike.
        </p>

      </div>

      <div className="jba-section">

        <h2>Our Vision</h2>

        <p>
          A hiring ecosystem where employers
            can confidently find qualified talent,
            job seekers can access meaningful
            opportunities, and career professionals
            can provide personalized support
            through every stage of the employment journey.
        </p>

      </div>

      <div className="jba-values">

        <div className="jba-card">
          <h3>🏡 Local First</h3>
          <p>
            Supporting employers and talent
            within our communities.
          </p>
        </div>

        <div className="jba-card">
          <h3>🤝 Meaningful Connections</h3>
          <p>
            Helping people connect beyond
            resumes and job postings.
          </p>
        </div>

        <div className="jba-card">
          <h3>📈 Career Development</h3>
          <p>
            Providing coaching, resources,
            and guidance for long-term success.
          </p>
        </div>

        <div className="jba-card">
          <h3>🌎 Community Prosperity</h3>
          <p>
            Strong employment creates
            stronger communities.
          </p>
        </div>

      </div>

      <div className="jba-section">

        <h2>Why We Exist</h2>

        <p>
          Traditional job boards focus on volume.
          The Community Job Bank focuses on relationships.
          By combining local job postings, career coaching,
          employer engagement, and hiring events into a
          single platform, we help create stronger employment
          outcomes for everyone involved.
        </p>

      </div>
      {createPortal(
        <GlobalNavDrawer
          hideCurrent
          links={[
            { to: "/purchase", label: `Tokens: ${balance}`},
            { to: "/jobbank", label: "Job Bank Home"},
            { to: "/voicebot", label: "iSpeakWell" },
            { to: "/resumerevisor", label: "Resumes" },
            { to: "/conversationpractice", label: "Convos" },
            { to: "/interview-practice", label: "Interviews" },
            { to: "/termsofservice", label: "Terms" },
            { to: "/privacypolicy", label: "Privacy" },
            { to: "/admin", label: "Admin" },
            { to: "/login", label: "Logout", onClick: async () => { await logout(); } },
          ]}
        />,
          document.body
      )}
    </div>
  );
}